<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>修改個人基本兵役資料</h2>

      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><a href="/bursary/military/base">個人基本兵役資料</a></li>
          <li><span>修改個人基本兵役資料</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div class="col-md-13">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">個人基本兵役資料</h2>
          </header>
          <div class="panel-body">
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">學　　　制：</label>
                <div class="col-sm-4">{{item.educateSystem}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">科　　　系：</label>
                <div class="col-sm-4">{{item.deptName}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">年級／班級：</label>
                <div class="col-sm-4">{{item.dradeClass}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">姓　　　名：</label>
                <div class="col-sm-4">{{item.studentName}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">生　　　日：</label>
                <div class="col-sm-4">{{item.birthday}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">身　分　證：</label>
                <div class="col-sm-4">{{item.idno}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">學　　　號：</label>
                <div class="col-sm-4">{{item.studentId}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">電　　　話：</label>
                <div class="col-sm-4">{{item.tel}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">手　　　機：</label>
                <div class="col-sm-4">{{item.phone}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">地　　　址：</label>
                <div class="col-sm-4">{{item.address}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">入 學 日 期 ：</label>
                <div class="col-sm-4">{{item.entryYM}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">畢 業 日 期 ：</label>
                <div class="col-sm-4">{{item.preGradYM}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">在 學 狀 態 ：</label>
                <div class="col-sm-4">
                  {{item.state}}
                  <span style="margin-left: 10px;" v-if="(item.state=='休學'||item.state=='轉學'||item.state=='退學')&&item.restOrOutDate">
                    ( 離校日期: {{item.restOrOutDate}} )
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-3">當 兵 狀 態 ：</label>
                <div class="col-sm-9">
                  <select v-model="form.status" @change.prevent="statusChagne">
                    <option :value="null">請選擇</option>
                    <option value="未役">未役</option>
                    <option value="已役">已役</option>
                    <option value="其他">其他</option>
                  </select>　
                  <div v-show="form.status=='已役'" style="display: inline-block; margin-left: 5px;">
                    階級：<select v-model="form.commission">
                      <option :value="null">請選擇</option>
                      <option value="二等兵">二等兵</option>
                      <option value="一等兵">一等兵</option>
                      <option value="上等兵">上等兵</option>
                      <option value="下士">下士</option>
                      <option value="中士">中士</option>
                      <option value="上士">上士</option>
                      <option value="士官長">士官長</option>
                      <option value="補充兵">補充兵</option>
                    </select>
                  </div>
                  <div v-show="form.status=='其他'" style="display: inline-block; margin-left: 5px;">
                    <select v-model="form.otherReason">
                      <option :value="null">請選擇</option>
                      <option value="停役">停役</option>
                      <option value="免役">免役</option>
                      <option value="現役">現役</option>
                      <option value="除役">除役</option>
                      <option value="替代役">替代役</option>
                      <option value="國民兵">國民兵</option>
                    </select>
                  </div>
                  <div v-show="form.status=='已役'||form.status=='其他'" style="display: inline-block; margin-left: 5px;">
                    佐證資料：<input ref="evidenceFile" type="file" style="display: inline-block; max-width: 150px;" />
                    <a :href="item.evidenceFile" v-if="item.evidenceFile" style="margin-left: 5px;">已上傳之佐證資料</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">身分證正面：</label>
                <div class="col-sm-4">
                  <div v-if="item.idCardPosit" style="position:relative;">
                    <div v-if="checkIdCardFileIsImage(item.idCardPosit)">
                      <a :href="item.idCardPosit" target="_blank" @mouseover="idCardShow(0)" @mouseout="idCardHide(0)">{{item.studentName}}身分證正面</a>
                      <div ref="divIdCardPosit" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                        <h4 class="blue">姓名：{{item.studentName}}　身分證字號：{{item.idno}}</h4>
                        <img :src="item.idCardPosit" style="max-width:400px; max-height:174px;">
                      </div>
                    </div>
                    <div v-else>
                      <a :href="item.idCardPosit" target="_blank">{{item.studentName}}身分證正面</a>
                    </div>
                  </div>
                  <input ref="idCardPosit" type="file" accept=".jpg,.png,.pdf" />
                </div>
              </div>
              <div class="group">
                <label class="col-sm-2">身分證反面：</label>
                <div class="col-sm-4">
                  <div v-if="item.idCardRever" style="position:relative;">
                    <div v-if="checkIdCardFileIsImage(item.idCardRever)">
                      <a :href="item.idCardRever" target="_blank" @mouseover="idCardShow(1)" @mouseout="idCardHide(1)">{{item.studentName}}身分證反面</a>
                      <div ref="divIdCardRever" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                        <h4 class="blue">姓名：{{item.studentName}}　身分證字號：{{item.idno}}</h4>
                        <img :src="item.idCardRever" style="max-width:400px; max-height:174px;">
                      </div>
                    </div>
                    <div v-else>
                      <a :href="item.idCardRever" target="_blank">{{item.studentName}}身分證反面</a>
                    </div>
                  </div>
                  <input ref="idCardRever" type="file" accept=".jpg,.png,.pdf" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-3">備　　　考：</label>
                <div class="col-sm-9"><textarea v-model="form.reference" rows="3" style="width: inherit;"></textarea></div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-3">　審核狀態：</label>
                <div class="col-sm-9">
                  <div class="radio-custom radio-primary" style="display: inline-block; margin-right: 10px;">
                    <input id="adminCheck_1" type="radio" :value="true" v-model="form.adminCheck" />
                    <label for="adminCheck_1">審核通過</label>
                  </div>
                  <div class="radio-custom radio-primary" style="display: inline-block;">
                    <input id="adminCheck_2" type="radio" :value="false" v-model="form.adminCheck" />
                    <label for="adminCheck_2">審核不通過</label>
                  </div>
                </div>
              </div>
            </div>
            <br><br />
            <table width="100%">
              <tr>
                <td style="text-align: left;">
                  <router-link v-if="prevStuId" :to="'/military/base/edit/'+prevStuId" class="btn-upload btn" style="background-color:#FF7744; border-color:#FF5511; color:#FFF;">上　一　位</router-link>　
                  <span v-else disabled="disabled" class="btn-upload btn" style="background-color:#FF7744; border-color:#FF5511; color:#FFF;">上　一　位</span>　
                </td>
                <td style="text-align: center;">
                  <router-link to="/military/base" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">返　　回</router-link>
                  <a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>
                  <a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">儲　　存</a>
                </td>
                <td style="text-align: right;">
                  <router-link v-if="nextStuId" :to="'/military/base/edit/'+nextStuId" class="btn-upload btn" style="background-color:#FF7744; border-color:#FF5511; color:#FFF;">下　一　位</router-link>
                  <span v-else disabled="disabled" class="btn-upload btn" style="background-color:#FF7744; border-color:#FF5511; color:#FFF;">下　一　位</span>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>
    </div>
    <div id="tabs-03" class="row">
      <section class="panel panel-collapsed">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h2 class="panel-title">基本資料歷史紀錄</h2>
        </header>
        <div class="panel-body">
          <table class="table table-no-more table-bordered table-striped mb-none">
            <thead>
              <tr>
                <th class="text-center" width="10%">筆數</th>
                <th class="text-center" width="30%">日期</th>
                <th class="text-center" width="60%">查看資料</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(history, index) in item.studentHistoryList" :key="index">
                <td data-title="筆數" class="text-center">{{index + 1}}</td>
                <td data-title="日期" class="text-center">{{history.strCrDate}}</td>
                <td data-title="查看資料" class="text-center"><input type="button" @click.prevent="historyOpen(history.id)" value="查看資料"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <div id="tabs-03" class="row">
      <section class="panel panel-collapsed">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h2 class="panel-title">申請/消滅歷史紀錄</h2>
        </header>
        <div class="panel-body">
          <table class="table table-no-more table-bordered table-striped mb-none">
            <thead>
              <tr>
                <th class="text-center" width="10%">筆數</th>
                <th class="text-center" width="90%">狀況</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(history, index) in item.applyHistoryList" :key="index">
                <td data-title="筆數" class="text-center">{{index + 1}}</td>
                <td data-title="狀況">
                  {{history.crDate}} 回傳{{history.applyItem}}
                  <span v-if="history.applyPostDateText">發文日期及文號：{{history.applyPostDateText}}</span>
                  <span v-if="history.applyReceivedDateText">回文日期及文號：{{history.applyReceivedDateText}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <div id="small-dialog" class="dialog zoom-anim-dialog mfp-hide" style="max-width: 1000px; padding: 0;">
      <section class="panel">
        <header class="panel-heading">
          <h2 class="panel-title">個人基本兵役資料</h2>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">學　　　制：</label>
              <div class="col-sm-4">{{studentHistory.educateSystem}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">科　　　系：</label>
              <div class="col-sm-4">{{studentHistory.deptName}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">年級／班級：</label>
              <div class="col-sm-4">{{studentHistory.dradeClass}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">姓　　　名：</label>
              <div class="col-sm-4">{{studentHistory.studentName}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">生　　　日：</label>
              <div class="col-sm-4">{{studentHistory.birthday}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">身　分　證：</label>
              <div class="col-sm-4">{{studentHistory.idno}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">學　　　號：</label>
              <div class="col-sm-4">{{studentHistory.studentId}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">電　　　話：</label>
              <div class="col-sm-4">{{studentHistory.tel}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">手　　　機：</label>
              <div class="col-sm-4">{{studentHistory.phone}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">地　　　址：</label>
              <div class="col-sm-4 s_bule">{{studentHistory.address}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">入 學 日 期 ：</label>
              <div class="col-sm-4">{{studentHistory.entryYM}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">畢 業 日 期 ：</label>
              <div class="col-sm-4">{{studentHistory.preGradYM}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">在 學 狀 態 ：</label>
              <div class="col-sm-4 s_bule">{{studentHistory.state}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">當 兵 狀 態 ：</label>
              <div class="col-sm-4">{{studentHistory.status}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">身分證正面：</label>
              <div class="col-sm-4">
                <div v-if="studentHistory.idCardPosit">
                  <div v-if="checkIdCardFileIsImage(studentHistory.idCardPosit)">
                    <a :href="studentHistory.idCardPosit" target="_blank" @mouseover="idCardHistoryShow(0)" @mouseout="idCardHistoryHide(0)">{{studentHistory.studentName}}身分證正面</a>
                    <div ref="divHistoryIdCardPosit" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                      <h4 class="blue">姓名：{{studentHistory.studentName}}　身分證字號：{{studentHistory.idno}}</h4>
                      <img :src="studentHistory.idCardPosit" style="max-width:400px; max-height:174px;">
                    </div>
                  </div>
                  <div v-else>
                    <a :href="studentHistory.idCardPosit" target="_blank">{{studentHistory.studentName}}身分證正面</a>
                  </div>
                </div>
              </div>
              <label class="col-sm-2">身分證反面：</label>
              <div class="col-sm-4">
                <div v-if="studentHistory.idCardRever">
                  <div v-if="checkIdCardFileIsImage(studentHistory.idCardRever)">
                    <a :href="studentHistory.idCardRever" target="_blank" @mouseover="idCardHistoryShow(1)" @mouseout="idCardHistoryHide(1)">{{studentHistory.studentName}}身分證反面</a>
                    <div ref="divHistoryIdCardRever" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                      <h4 class="blue">姓名：{{studentHistory.studentName}}　身分證字號：{{studentHistory.idno}}</h4>
                      <img :src="studentHistory.idCardRever" style="max-width:400px; max-height:174px;">
                    </div>
                  </div>
                  <div v-else>
                    <a :href="studentHistory.idCardRever" target="_blank">{{studentHistory.studentName}}身分證反面</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-3">備　　　考：</label>
              <div class="col-sm-9">{{studentHistory.reference}}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      studentHistory: {},
      form: {
        status: null,
        commission: null,
        otherReason: null,
        evidenceFile: null,
        idCardPosit: null,
        idCardRever: null,
        reference: "",
        adminCheck: null,
      },
      tempEvidenceFile: null,
    };
  },
  computed: {
    stuId() {
      return this.$route.params.id;
    },
    baseStuIdList() {
      let result = [];
      if(window.sessionStorage.getItem("militaryBaseStuIdList")){
        result = JSON.parse(window.sessionStorage.getItem("militaryBaseStuIdList"))
      }
      return result;
    },
    prevStuId() {
      let nowIndex = this.baseStuIdList.indexOf(this.stuId);
      if (nowIndex - 1 < 0) return null;
      return this.baseStuIdList[nowIndex - 1];
    },
    nextStuId() {
      let nowIndex = this.baseStuIdList.indexOf(this.stuId);
      if (nowIndex + 1 >= this.baseStuIdList.length) return null;
      return this.baseStuIdList[nowIndex + 1];
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/military/info/" + this.stuId).then((a) => {
        this.item = a.body;
        this.form.status = a.body.status;
        this.form.commission = a.body.commission;
        this.form.otherReason = a.body.otherReason;
        if (this.item.idCardPosit)
          this.item.idCardPosit = "/upload/" + this.item.idCardPosit;
        if (this.item.idCardRever)
          this.item.idCardRever = "/upload/" + this.item.idCardRever;
        this.form.reference = a.body.reference;
        this.form.adminCheck = a.body.adminCheck;
      });
    },
    formClear() {
      this.load();
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      let formData = new FormData();
      formData.append("status", this.form.status);
      formData.append("commission", this.form.commission);
      formData.append("otherReason", this.form.otherReason);
      formData.append("reference", this.form.reference);
      formData.append("EvidenceFile", this.form.evidenceFile);
      formData.append("IdCardPosit", this.form.idCardPosit);
      formData.append("IdCardRever", this.form.idCardRever);
      if(this.form.adminCheck != null){
        formData.append("adminCheck", this.form.adminCheck);
      }
      this.$http
        .post("/api/military/info/" + this.stuId, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((a) => {
          if (a.body.status) {
            alert("儲存成功");
            this.$refs.evidenceFile.value = null;
            this.$refs.idCardPosit.value = null;
            this.$refs.idCardRever.value = null;
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    checkForm() {
      if (
        !this.form.status ||
        (this.form.status == "已役" && !this.form.commission) ||
        (this.form.status == "其他" && !this.form.otherReason)
      ) {
        alert("『當兵狀態』尚未選擇完整");
        return false;
      }
      
      switch (this.form.status) {
        case "未役":
          this.form.commission = null;
          this.form.otherReason = null;
          break;
        case "已役":
          this.form.otherReason = null;
          break;
        case "其他":
          this.form.commission = null;
          break;
      }
      if(!this.isAdmin('military')){
        if (this.form.status == "已役" || this.form.status == "其他") {
          this.form.evidenceFile = this.$refs.evidenceFile.files[0];
          if (!this.item.evidenceFile && !this.form.evidenceFile) {
            alert("『佐證資料』尚未選擇檔案");
            return false;
          }
        }
        this.form.idCardPosit = this.$refs.idCardPosit.files[0];
        if (!this.item.idCardPosit) {
          if (!this.form.idCardPosit) {
            alert("『身分證正面』尚未選擇檔案");
            return false;
          }
        }
        this.form.idCardRever = this.$refs.idCardRever.files[0];
        if (!this.item.idCardRever) {
          if (!this.form.idCardRever) {
            alert("『身分證反面』尚未選擇檔案");
            return false;
          }
        }
        if (this.form.adminCheck == null) {
          alert("『審核狀態』尚未選擇");
          return false;
        }
      }
      
      return true;
    },
    idCardShow(v) {
      if (v == 0) {
        $(this.$refs.divIdCardPosit).show();
      } else {
        $(this.$refs.divIdCardRever).show();
      }
    },
    idCardHide(v) {
      if (v == 0) {
        $(this.$refs.divIdCardPosit).hide();
      } else {
        $(this.$refs.divIdCardRever).hide();
      }
    },
    idCardHistoryShow(v) {
      if (v == 0) {
        $(this.$refs.divHistoryIdCardPosit).show();
      } else {
        $(this.$refs.divHistoryIdCardRever).show();
      }
    },
    idCardHistoryHide(v) {
      if (v == 0) {
        $(this.$refs.divHistoryIdCardPosit).hide();
      } else {
        $(this.$refs.divHistoryIdCardRever).hide();
      }
    },
    historyOpen(id) {
      this.studentHistory = this.item.studentHistoryList.filter((a) => {
        return a.id == id;
      })[0];
      $.magnificPopup.open(
        {
          items: { src: "#small-dialog" },
          type: "inline",
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: "auto",
          closeBtnInside: true,
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: "my-mfp-zoom-in",
        },
        0
      );
    },
    checkIdCardFileIsImage(fileName) {
      if (!fileName) return false;
      return this.checkFileExtension(fileName, ["jpg","jpeg","png"]);
      // let fileNameArray = fileName.split(".");
      // let fileExtName = fileNameArray[fileNameArray.length - 1];
      // switch (fileExtName) {
      //   case "jpg":
      //   case "png":
      //     return true;
      // }
      return false;
    },
    statusChagne() {
      if (this.item.status) {
        if (this.form.status != this.item.status) {
          this.tempEvidenceFile = this.item.evidenceFile;
          this.item.evidenceFile = null;
        } else {
          this.item.evidenceFile = this.tempEvidenceFile;
        }
      }
    },
  },
  watch: {
    stuId() {
      this.load();
    },
  },
};
</script>

<style>
</style>